import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "api";
import { proceedThunk } from "./utils";

export const getStatsThunk = createAsyncThunk(
  "stats/get",
  proceedThunk(api.takebaker.other.stats)
);
